import { scarpaGray50, scarpaGray800, spanishViridian400 } from '@habitech/shared';
import styled from 'styled-components';

export const ContainerFilters = styled.section`
    display: flex;
    gap: 16px;
    border-radius: 8px;
    margin: 8px 0 16px;
    border: 1px solid ${scarpaGray50};
    padding: 8px;
    .title {
        font-size: 12px;
        font-weight: 500;
        line-height: 40px;
        text-transform: uppercase;
        color: ${spanishViridian400};
    }
`;

export const FilterItem = styled.div`
    display: flex;
    gap: 8px;
    border-radius: 8px;
    background: ${scarpaGray50};
    padding: 8px;
    .label {
        text-transform: uppercase;
        color: ${scarpaGray800};
        font-weight: 500;
        font-size: 14px;
    }
    
`;
